export default __webpack_public_path__ + "static/dawid-dd33425928c9db631ac6eee6533ea92e.png";